<template>
        <div class="root" v-observe-visibility="{
                callback: isVisible,
                once: true}">

                <h2>
                        {{title}}
                </h2>
                <div v-html="intro" class="intro"/>

                <h2>{{pie_title}}</h2>
                <div class="row">
                        <div class="col-lg-6 chart-container">
                                <pie-chart
                                        :chartdata = "chartdata"
                                        :options = "chartoptions"
                                        v-if = "loaded && visible"
                                        :activePie = "activePie"
                                        v-on:element-hovered="elementHovered"
                                >
                                </pie-chart>

                                <div class="investment-date">{{date}}</div>
                        </div>
                        <div class="col-lg-6">
                                <ul class="invest-legend">
                                        <li v-for="(entry,idx) in legend"  :key="`entry-${idx}`" v-on:mouseover="highlightPie(idx)" v-on:mouseleave="highlightPie(null)" v-bind:class="{active: idx === activePie}">
                                                <span v-bind:style="{backgroundColor: entry.color}" class="box"></span>
                                                <span>{{entry.title}} {{entry.value}}%</span>
                                        </li>
                                </ul>
                                <a v-bind:href="infoblatt.link" target="_blank" v-if="infoblatt" class="iul-invest">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="20" height="20" viewBox="0 0 20 20">
                                                <path d="M14.853 9.647c-0.195-0.195-0.512-0.195-0.707 0l-4.146 4.146v-11.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5
                                                        0.5v11.293l-4.146-4.146c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5 5c0.098 0.098
                                                        0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.147l5-5c0.195-0.195 0.195-0.512-0-0.707z" fill="#000000"/>
                                                <path d="M17.5 19h-16c-0.827 0-1.5-0.673-1.5-1.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276 0.224 0.5
                                                        0.5 0.5h16c0.276 0 0.5-0.224 0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5
                                                        0.224 0.5 0.5v2c0 0.827-0.673 1.5-1.5 1.5z" fill="#000000"/>
                                        </svg>{{infoblatt.title}}</a>
                        </div>
                </div>


        </div>
</template>

<script>
        import axios from "axios";
        import PieChart from '../components/PieChart.js';

        export default {
                components: {
                        PieChart
                },
                computed: {
                        title() {
                                return this.$store.state.investments.title;
                        },
                        intro() {
                                return this.$store.state.investments.intro;
                        },
                        pie_title() {
                             return this.$store.state.investments.title_pie;
                        },
                        infoblatt() {
                                return this.$store.state.investments.infoblatt;
                        },

                        date() {
                                return this.$store.state.investments.date; // Freitext zur Anzeige einer Erhebungsgültigkeit
                        },

                        chartdata() {
                                if (this.loaded) {
                                        let labelsArr = [], colorsArr = [], dataArr = [];

                                        const rawdata = this.$store.state.investments.data;

                                        for (let i = 1, j = rawdata.length; i < j; i++) {
                                                if (rawdata[i][0] !== "") {
                                                        labelsArr.push(rawdata[i][0]);
                                                        colorsArr.push(rawdata[i][2]);
                                                        dataArr.push(parseFloat(rawdata[i][1]));
                                                }
                                        }

                                        return  {
                                                'labels': labelsArr,
                                                'datasets': [{
                                                        'data': dataArr,
                                                        'backgroundColor': colorsArr
                                                }]
                                        }

                                }
                                return null;
                        },
                        legend() {

                                if (!this.loaded) return null;

                                let legend = [];

                                const rawdata = this.$store.state.investments.data;

                                for (let i = 1, j = rawdata.length; i < j; i++) {
                                        legend.push({
                                                title: rawdata[i][0],
                                                value: rawdata[i][1],
                                                color: rawdata[i][2]
                                        })

                                }
                                return legend;
                        }
                },

                async mounted() {
                        const self = this;
                        axios
                        .get(process.env.VUE_APP_DATAHUB_URL + "investments")
                        .then((response) => {
                                self.$store.dispatch("addInvestmentsData", response.data)
                                        .then(() => {
                                                self.loaded = true;
                                        })

                        })
                },
                data () {
                        return {
                                loaded: false,
                                chartoptions: {
                                        cutoutPercentage: 30,
                                        legend: {
                                                display: false
                                        },
                                        maintainAspectRatio: false,
                                        animation: {
                                                duration: 2500,
                                                onComplete: function() {

                                                },
                                        },
                                        responsive:true,

                                        tooltips: {
                                                showTooltips: true
                                        }


                                },
                                visible: false,
                                activePie: null,

                        }
                },
                methods: {
                        isVisible(isVisible, entry) {
                                this.visible = isVisible
                        },

                        highlightPie(idx) {
                                this.activePie = idx;
                        },
                        elementHovered(elementdaata) {
                                this.activePie = elementdaata.idx;
                        }

                },
        }
</script>

<style lang="scss" scoped>

        h1, h2 {
                text-align: left;
                margin-bottom: 20px;
        }

        .intro {
                margin-bottom:60px;
        }

        .investment-date {
                font-size:12px;
                margin-top: 35px;
                text-align:center;
                color:#505050;
        }


        .invest-legend li{
                display:flex;
                flex-direction: row;
                align-content: center;
                cursor:pointer;
                &:hover, &.active {
                        background: #efefef
                }
                .box {
                        display:inline-block;
                        height: 30px;
                        width:30px;
                        margin-right:1em;
                }
        }
        .row > div {
                padding:2em;
        }

        .iul-invest {
                display: flex;
                justify-content: flex-start;
                color: #0082C8;
                font-weight:bold;
                text-decoration: underline;
                margin-top:45px;
                svg {
                        margin-right: 8px;

                        path {
                                fill:#0082C8;
                        }
                }
        }
</style>
